import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.pages.AppProjectPage.';
  public static readonly projectEditorTitle = `${Id.prefix}projectEditorTitle`;
  public static readonly projectGlossary = `${Id.prefix}projectGlossary`;
}

export class LangAppProjectPage {
  private constructor() {}
  public static projectEditorTitle(): string {
    return interpolate(Id.projectEditorTitle);
  }
  public static projectGlossary(): string {
    return interpolate(Id.projectGlossary);
  }
}

export class AppProjectPageModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.projectEditorTitle, "{{glossary 'project'}} Editor", 'Title for the project editor page');
    register.add(Id.projectGlossary, "{{glossary 'project'}}", 'Glossary term for project (singular)');
  }
}
